// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"343":"57080a42","958":"1229d241"}[chunkId] + ".css";
};